
import { apiUserLogin,  apiUserSignUp } from "../utils/api.js"; 


class AuthService {
  login(user) {
    return apiUserLogin({
      username: user.username,
      password: user.password
    })
    .then(response=> {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
    })   
  }

  logout() {
    localStorage.removeItem('user');
  }

  register(user) {  
    return apiUserSignUp({
      username: user.username,
      nickname: user.nickname,
      password: user.password
    });
  }
}

export default new AuthService();
